import cx from 'classnames';
import React from 'react';
import { Icon } from '../../../../icon';
import { Colors, Typography } from '../../../../typography';
import styles from './text-cell.module.scss';
export const TextCell = ({ data, colDef, }) => {
    const values = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) ? data[colDef.colId] : {};
    return (React.createElement("div", { className: cx(styles.textCellContainer, {
            [styles.textCellContainerDisabled]: values.disabled,
        }) },
        values.icon && (React.createElement(Icon, { className: styles.icon, id: values.icon, color: values.iconSize, size: values.iconColor })),
        React.createElement("div", null,
            values.text && (React.createElement(Typography, { variant: values.boldText
                    ? 'content-label-subhead'
                    : 'body-normal', noMargin: true }, values.text)),
            values.subtext && (React.createElement(Typography, { className: styles.subtext, color: Colors.grayLight, variant: "caption", noMargin: true }, values.subtext)))));
};
//# sourceMappingURL=text-cell.js.map